import React, { useEffect, useState } from "react";
import Header from "../component/layout/Header";
import Footer from "../component/layout/Footer";
import api from "../utils/api"; // Adjust the import path as per your project structure
import "./styles.css"
import { FaSpinner } from "react-icons/fa";

const TermsAndConditions = () => {
  const [terms, setTerms] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTermsAndConditions = async () => {
      setLoading(true);
      try {
        const response = await api.get("/static-pages?type=terms-condition");
        if (response?.data?.results) {
          setTerms(response.data.results);
        }
      } catch (error) {
        console.error("Error fetching terms and conditions:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTermsAndConditions();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when the page loads
  }, []);

  return (
    <>
      <Header />
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-4xl font-bold text-center text-[#C97C2A] mb-8">
          Terms and Conditions
        </h1>
        {loading ? (
           <div className="flex justify-center items-center min-h-screen">
           <FaSpinner className="animate-spin text-4xl text-[#C97C2A]" />
         </div>
        ) : (
          <div className="grid grid-cols-1  gap-6">
            {terms.map((term) => (
              <div
                key={term._id}
                className="bg-white shadow-lg rounded-lg p-6 hover:shadow-xl transition-shadow duration-300"
              >
                <h2 className="text-2xl font-semibold text-gray-800 mb-4">
                  {term.title}
                </h2>
                <p dangerouslySetInnerHTML={{__html: term.content}} className="text-gray-700 mb-4 quill-content"></p>
                <p className="text-sm text-gray-500">
                  Last Updated: {new Date(term.updatedAt).toLocaleDateString()}
                </p>
              </div>
            ))}
          </div>
        )}
        {!loading && terms.length === 0 && (
          <div className="flex justify-center items-center">
            <p className="text-lg text-gray-500">
              No terms and conditions available at the moment.
            </p>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default TermsAndConditions;
